import callCmAPI from 'services/helpers/call-cm-api'

/******************
 * Fetch from API *
 ******************/

export const issueUserApiToken = (apiUserId: string) =>
  callCmAPI(`/user/api/token/${apiUserId}`, {
    method: 'get',
  })
    .then((res) => res.data)
    .catch((err) => err)
